module.exports = __webpack_public_path__ + "static/img/thumb_29.cd4bbf1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu/thumb_29.png
// module id = KQkk
// module chunks = 0